module.exports = __webpack_public_path__ + "static/media/loginBlock.a3b5f2fa.jpg";